import * as React from 'react'
import { OnClickMenu, OnClickMenuItem } from 'uiComponents/menus/'
import { Text } from 'uiComponents/typography'
import { faTrash, faPencilAlt, faPencilPaintbrush, faTimesOctagon } from '@fortawesome/pro-light-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { UnstyledLink } from 'uiComponents/navigation/unstyledLink'
import { useTranslation } from 'translations'

type FunctionType = () => void

interface MenuProps {
    studioHref: string
    onUnpublish: FunctionType | null
    onPublish: FunctionType | null
    onEditInfo: FunctionType | null
    onDelete: FunctionType
}

export function ActionMenu(props: MenuProps) {
    const handlePublish = props.onUnpublish || props.onPublish
    const { t } = useTranslation()

    return (
        <OnClickMenu title={t('engageTools.overview.actionMenu.title')} kind="action" width="12em" secondary alignRight>
            {handlePublish && (
                <OnClickMenuItem onClick={handlePublish}>
                    <FontAwesomeIcon icon={faTimesOctagon} style={{ marginRight: '0.5em' }} />
                    {props.onUnpublish ? t('engageTools.overview.actionMenu.unpublish') : t('engageTools.overview.actionMenu.publish')}
                </OnClickMenuItem>
            )}

            <OnClickMenuItem>
                <UnstyledLink to={props.studioHref}>
                    <>
                        <FontAwesomeIcon icon={faPencilPaintbrush} style={{ marginRight: '0.5em' }} />
                        {t('engageTools.overview.actionMenu.studio')}
                    </>
                </UnstyledLink>
            </OnClickMenuItem>
            {props.onEditInfo && (
                <OnClickMenuItem onClick={props.onEditInfo}>
                    <FontAwesomeIcon icon={faPencilAlt} style={{ marginRight: '0.5em' }} />
                    {t('engageTools.overview.actionMenu.editInfo')}
                </OnClickMenuItem>
            )}
            <OnClickMenuItem onClick={props.onDelete}>
                <Text status="error">
                    <FontAwesomeIcon icon={faTrash} style={{ marginRight: '0.5em' }} />
                    {t('common.delete')}
                </Text>
            </OnClickMenuItem>
        </OnClickMenu>
    )
}
